<div class="brand-container">
  <div class="brand">
    <img class="pb-4 d-none d-md-block" src="{{env.theme.assetsDir}}/images/vertical_logo.png" />
    <img class="pb-4 d-block d-md-none" src="{{env.theme.assetsDir}}/images/horizontal_logo.png" />
  </div>
</div>
